module.exports = __webpack_public_path__ + "static/img/66.45e4d09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/66.png
// module id = pK9O
// module chunks = 0